module.exports = __webpack_public_path__ + "static/media/Element_Electro.af270725.png";